import { TbArrowLeft } from "react-icons/tb";
import { NavLink } from "react-router-dom";

export function Header({name, backName, backLink}:{name: string, backName: string, backLink: string}) {
    return (
        <div className="flex flex-none w-full h-24 text-base gap-2 items-center justify-between px-6">
          <div className="flex flex-col space-y-1">
            <NavLink to={backLink} className="text-sm flex gap-2 items-center text-muted-foreground"><TbArrowLeft />{backName}</NavLink>
            <span className="text-2xl font-semibold">{name}</span>
          </div>
        </div>
    )
}